export const labyrinthQuest = {
    id: 'the_labyrinth',
    titleKey: 'chapter_labyrinth',
    shortName: 'LABYRINTH',
    date: '15.01.2026',
    status: 'completed',
    questMap: [
        {
            id: 'step_talk_jaeger_1',
            label: {
                en: "Getting a Quest / Ask Jaeger about the underground facility",
                tr: "Görev alma / Jaeger'e yeraltı tesisi hakkında sor",
                ru: "Получение квеста / Спросить Егеря о подземном объекте"
            },
            type: 'start',
            isSubTask: false,
            details: {
                location: { en: "Menu / Traders", tr: "Menü / Satıcılar", ru: "Меню / Торговцы" },
                objective: {
                    en: "Visit Jaeger and ask him about the underground facility.",
                    tr: "Jaeger'i ziyaret et ve ona yeraltı tesisi hakkında sorular sor.",
                    ru: "Посетите Егеря и спросите его о подземном объекте."
                },
                story: {
                    en: "Even before the raid on the TerraGroup office, I'd heard about their underground sites in Tarkov. They say that under the coastal Health Resort, a few months back, they found either a bomb shelter or another lab - 'The Labyrinth'... I should definitely check that place.",
                    tr: "TerraGroup ofisine yaptığımız baskından önce bile, Tarkov'daki yeraltı tesisleri hakkında bir şeyler duymuştum. Birkaç ay önce sahil tarafındaki Sağlık Merkezi'nin (Health Resort) altında bir sığınak veya başka bir laboratuvar bulduklarını söylüyorlar - 'Labirent' (The Labyrinth)... Orayı kesinlikle kontrol etmeliyim.",
                    ru: "Еще до рейда на офис TerraGroup я слышал об их подземных объектах в Таркове. Говорят, что под береговым Санаторием несколько месяцев назад нашли либо бомбоубежище, либо еще одну лабораторию - «Лабиринт»... Мне определенно стоит проверить это место."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Open the Traders menu. Select Jaeger. Ask him about the underground facility beneath the Health Resort.",
                            tr: "Satıcılar menüsünü aç. Jaeger'i seç. Sağlık Merkezi'nin (Health Resort) altındaki yeraltı tesisi hakkında ona sor.",
                            ru: "Откройте меню торговцев. Выберите Егеря. Спросите его о подземном объекте под Санаторием."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_wait_jaeger_keycards',
            label: {
                en: "Wait for Jaeger to gather the keycards",
                tr: "Jaeger'in anahtar kartları toplamasını bekle",
                ru: "Дождаться, пока Егерь соберёт ключ-карты"
            },
            type: 'wait',
            isSubTask: false,
            details: {
                location: { en: "Menu / Traders", tr: "Menü / Satıcılar", ru: "Меню / Торговцы" },
                objective: {
                    en: "Wait 24-48 hours for Jaeger to gather the Labrys access keycards.",
                    tr: "Jaeger'in Labrys erişim anahtar kartlarını (keycards) toplaması için 24-48 saat bekle.",
                    ru: "Подождите 24-48 часов, пока Егерь соберет ключ-карты доступа Лабрис."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Wait 24-48 hours (real time). Jaeger will send you 2 Labrys access keycards via in-game mail.",
                            tr: "Gerçek zamanlı olarak 24-48 saat bekle. Jaeger sana oyun içi posta yoluyla 2 adet Labrys erişim anahtar kartı gönderecek.",
                            ru: "Подождите 24-48 часов (реального времени). Егерь пришлет вам 2 ключ-карты доступа Лабрис через внутриигровую почту."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_access_labyrinth',
            label: {
                en: "Opening access to the Labyrinth / Access the underground facility",
                tr: "Labirent'e erişimi aç / Yeraltı tesisine gir",
                ru: "Открыть доступ в Лабиринт / Попасть на подземный объект"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Shoreline -> The Labyrinth", tr: "Kıyı Şeridi -> The Labyrinth", ru: "Берег -> Лабиринт" },
                objective: {
                    en: "Use a Labrys access keycard to transit from Shoreline to The Labyrinth.",
                    tr: "Kıyı Şeridi haritasından (Shoreline) Labirent'e (The Labyrinth) geçiş yapmak için Labrys erişim anahtar kartını kullan.",
                    ru: "Используйте ключ-карту доступа Лабрис для транзита с Берега в Лабиринт."
                },
                warning: {
                    en: "The Labyrinth can ONLY be entered via transit from Shoreline. It requires a Labrys access keycard AND the Knossos LLC facility key for the transit door.",
                    tr: "Labirent'e SADECE Kıyı Şeridi haritasındaki geçiş (transit) noktasından girilebilir. Geçiş kapısı için hem Labrys erişim anahtar kartı HEM DE Knossos LLC tesis anahtarı gereklidir.",
                    ru: "В Лабиринт можно попасть ТОЛЬКО через транзит с Берега. Требуется ключ-карта доступа Лабрис И ключ от объекта Knossos LLC для двери транзита."
                },
                requiredItems: [
                    { en: "Labrys access keycard", tr: "Labrys erişim anahtar kartı", ru: "Ключ-карта доступа Лабрис" },
                    { en: "Knossos LLC facility key", tr: "Knossos LLC tesis anahtarı", ru: "Ключ от объекта Knossos LLC" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Go to Shoreline. Enter the Health Resort west wing basement.",
                            tr: "Kıyı Şeridi (Shoreline) haritasına git. Sağlık Merkezi'nin (Health Resort) batı kanadındaki bodrum katına gir.",
                            ru: "Отправляйтесь на Берег. Войдите в подвал западного крыла Санатория."
                        },
                        images: ['/Story/Labyrinth/Shoreline-WestWing.webp']
                    },
                    {
                        text: {
                            en: "Use the Knossos LLC facility key to open the transit door in the basement.",
                            tr: "Bodrumdaki geçiş kapısını açmak için Knossos LLC tesis anahtarını kullan.",
                            ru: "Используйте ключ от объекта Knossos LLC, чтобы открыть дверь транзита в подвале."
                        },
                        images: ['/Story/Labyrinth/Transit-Door.webp']
                    },
                    {
                        text: {
                            en: "Use the Labrys access keycard at the transit point to enter The Labyrinth.",
                            tr: "Labirent'e girmek için geçiş noktasında Labrys erişim anahtar kartını kullan.",
                            ru: "Используйте ключ-карту доступа Лабрис в точке транзита, чтобы войти в Лабиринт."
                        },
                        images: ['/Story/Labyrinth/Transit-Point.webp']
                    }
                ]
            }
        },
        {
            id: 'step_find_bear_traces',
            label: {
                en: "Find BEAR's footprints in the Maze / Locate the traces of the BEAR squad",
                tr: "Labirent'te BEAR izlerini bul / BEAR takımının izlerini tespit et",
                ru: "Найти следы отряда BEAR в Лабиринте"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "The Labyrinth", tr: "The Labyrinth", ru: "Лабиринт" },
                objective: {
                    en: "Find Leshy's orders inside a food container in front of spawn chamber 2.",
                    tr: "Doğuş odası 2'nin (spawn chamber 2) önündeki yiyecek kabının içinde Leshy'nin emirlerini bul.",
                    ru: "Найдите приказы Лешего в контейнере с едой перед камерой спавна 2."
                },
                requiredItems: [
                    { en: "Leshy's orders", tr: "Leshy'nin emirleri", ru: "Приказы Лешего" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Enter The Labyrinth. Navigate to spawn chamber 2.",
                            tr: "Labirent'e gir. Doğuş odası 2'ye doğru ilerle.",
                            ru: "Войдите в Лабиринт. Направляйтесь к камере спавна 2."
                        },
                        images: ['/Story/Labyrinth/SpawnChamber2-Map.webp']
                    },
                    {
                        text: {
                            en: "Look for a food container on the ground in front of the chamber. Leshy's orders are inside.",
                            tr: "Odanın önündeki yerde duran yiyecek kabına bak. Leshy'nin emirleri içindedir.",
                            ru: "Посмотрите на землю перед камерой на контейнер с едой. Приказы Лешего внутри."
                        },
                        images: ['/Story/Labyrinth/LeshyOrders-Container.webp', '/Story/Labyrinth/LeshyOrders-Item.webp']
                    }
                ]
            }
        },
        {
            id: 'step_investigate_regroup',
            label: {
                en: "Investigate the BEAR squad regroup spot at Item 1156",
                tr: "Eşya 1156'daki BEAR takımının toplanma noktasını araştır",
                ru: "Исследовать точку перегруппировки отряда BEAR у Предмета 1156"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "The Labyrinth", tr: "The Labyrinth", ru: "Лабиринт" },
                objective: {
                    en: "Find the BEAR squad's regroup spot at the prototype weapon area (Item 1156).",
                    tr: "Prototip silah alanında (Eşya 1156) BEAR takımının yeniden toplanma noktasını bul.",
                    ru: "Найдите место перегруппировки отряда BEAR в зоне прототипного оружия (Предмет 1156)."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Navigate to the prototype weapon area in The Labyrinth.",
                            tr: "Labirent'teki prototip silah alanına doğru ilerle.",
                            ru: "Направляйтесь к зоне прототипного оружия в Лабиринте."
                        },
                        images: ['/Story/Labyrinth/PrototypeArea-Map.webp']
                    },
                    {
                        text: {
                            en: "Enter the area to trigger the objective completion.",
                            tr: "Görevi tamamlamak için alana gir.",
                            ru: "Войдите в зону, чтобы вызвать завершение задачи."
                        },
                        images: ['/Story/Labyrinth/PrototypeArea-View.webp']
                    }
                ]
            }
        },
        {
            id: 'step_find_squad_leader',
            label: {
                en: "Locate the squad leader / Gather more information about the squad",
                tr: "Takım liderini bul / Takım hakkında daha fazla bilgi topla",
                ru: "Найти командира отряда / Собрать больше информации об отряде"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "The Labyrinth", tr: "The Labyrinth", ru: "Лабиринт" },
                objective: {
                    en: "Find Leshy's diary next to the squad leader's body in the torture room.",
                    tr: "İşkence odasındaki takım liderinin cesedinin yanında Leshy'nin günlüğünü bul.",
                    ru: "Найдите дневник Лешего рядом с телом командира отряда в комнате пыток."
                },
                requiredItems: [
                    { en: "Leshy's diary", tr: "Leshy'nin günlüğü", ru: "Дневник Лешего" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Navigate to the torture room in The Labyrinth.",
                            tr: "Labirent'teki işkence odasına doğru ilerle.",
                            ru: "Направляйтесь к комнате пыток в Лабиринте."
                        },
                        images: ['/Story/Labyrinth/TortureRoom-Map.webp']
                    },
                    {
                        text: {
                            en: "The squad leader's body is near the torture room. Leshy's diary is located next to him.",
                            tr: "Takım liderinin cesedi işkence odasının yakınındadır. Leshy'nin günlüğü de onun yanındadır.",
                            ru: "Тело командира отряда находится рядом с комнатой пыток. Дневник Лешего лежит рядом с ним."
                        },
                        images: ['/Story/Labyrinth/SquadLeader-Body.webp', '/Story/Labyrinth/LeshyDiary-Item.webp']
                    }
                ]
            }
        },
        {
            id: 'step_investigate_scientists',
            label: {
                en: "Investigate the 5 lab staff bodies",
                tr: "5 laboratuvar personelinin cesedini araştır",
                ru: "Осмотреть тела 5 сотрудников лаборатории"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "The Labyrinth", tr: "The Labyrinth", ru: "Лабиринт" },
                objective: {
                    en: "Find and read all 5 assistant's notes located next to the dead scientists.",
                    tr: "Ölü bilim adamlarının yanındaki 5 asistan notunun tamamını bul ve oku.",
                    ru: "Найдите и прочитайте все 5 заметок ассистента рядом с мертвыми учеными."
                },
                warning: {
                    en: "One of the scientists will randomly spawn the Observation room key. Make sure to check all 5 bodies!",
                    tr: "Bilim adamlarından biri rastgele olarak Gözlem odası anahtarını (Observation room key) düşürür. 5 cesedin tamamını kontrol ettiğinden emin ol!",
                    ru: "Один из ученых случайно спавнит ключ от наблюдательной комнаты. Обязательно проверьте все 5 тел!"
                },
                requiredItems: [
                    { en: "Assistant's notes on Group 3", tr: "Grup 3 üzerine asistan notları", ru: "Заметки ассистента о Группе 3" },
                    { en: "Assistant's notes on Group 8", tr: "Grup 8 üzerine asistan notları", ru: "Заметки ассистента о Группе 8" },
                    { en: "Assistant's notes on Group 3 and Group 10", tr: "Grup 3 ve Grup 10 üzerine asistan notları", ru: "Заметки ассистента о Группе 3 и Группе 10" },
                    { en: "Assistant's notes on Group 12", tr: "Grup 12 üzerine asistan notları", ru: "Заметки ассистента о Группе 12" },
                    { en: "Assistant's notes on TG-Vi-24 test subjects", tr: "TG-Vi-24 denekleri üzerine asistan notları", ru: "Заметки ассистента об испытуемых TG-Vi-24" },
                    { en: "Observation room key", tr: "Gözlem odası anahtarı", ru: "Ключ от наблюдательной комнаты" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Scientist #1: Located near the tractor with bright headlights in the center room. The note is under his right hand.",
                            tr: "Bilim adamı #1: Merkez odadaki parlak farlı traktörün yakınında bulunur. Not sağ elinin altındadır.",
                            ru: "Ученый #1: Находится рядом с трактором с яркими фарами в центральной комнате. Заметка лежит под его правой рукой."
                        },
                        images: ['/Story/Labyrinth/Scientist1-Map.webp', '/Story/Labyrinth/Scientist1-Note.webp']
                    },
                    {
                        text: {
                            en: "Scientist #2: Found through the stone archway, past the barrels. The note is under his left arm.",
                            tr: "Bilim adamı #2: Varillerin ilerisindeki taş kemerin oradadır. Not sol kolunun altındadır.",
                            ru: "Ученый #2: Находится через каменную арку за бочками. Заметка лежит под его левой рукой."
                        },
                        images: ['/Story/Labyrinth/Scientist2-Map.webp', '/Story/Labyrinth/Scientist2-Note.webp']
                    },
                    {
                        text: {
                            en: "Scientist #3: Located in the nuke room behind the tractor. The note is next to the body.",
                            tr: "Bilim adamı #3: Traktörün arkasındaki nükleer odaya git. Not cesedin yanındadır.",
                            ru: "Ученый #3: В ядерной комнате за трактором. Заметка лежит рядом с телом."
                        },
                        images: ['/Story/Labyrinth/Scientist3-Map.webp', '/Story/Labyrinth/Scientist3-Note.webp']
                    },
                    {
                        text: {
                            en: "Scientist #4: Found in the room with wooden pallets, opposite the nuke room. This requires the Observation room key (which spawns randomly on any scientist). The note is under the body.",
                            tr: "Bilim adamı #4: Nükleer odanın karşısındaki ahşap paletli odadadır. Odaya girmek için Gözlem odası anahtarı (herhangi bir bilim adamından rastgele düşer) gerekir. Not cesedin altındadır.",
                            ru: "Ученый #4: В комнате с деревянными поддонами напротив ядерной комнаты. Требуется ключ от наблюдательной комнаты (случайный спавн на любом ученом). Заметка лежит под телом."
                        },
                        images: ['/Story/Labyrinth/Scientist4-Map.webp', '/Story/Labyrinth/Scientist4-Note.webp']
                    },
                    {
                        text: {
                            en: "Scientist #5: Lying face down in the corner by the garbage and boxes. The note is under his head.",
                            tr: "Bilim adamı #5: Çöp ve kutuların yanındaki köşede yüzükoyun yatmaktadır. Not kafasının altındadır.",
                            ru: "Ученый #5: Лежит лицом вниз в углу рядом с мусором и ящиками. Заметка находится под головой."
                        },
                        images: ['/Story/Labyrinth/Scientist5-Map.webp', '/Story/Labyrinth/Scientist5-Note.webp']
                    }
                ]
            }
        },
        {
            id: 'step_access_office',
            label: {
                en: "Access the locked office / Observation room",
                tr: "Kilitli ofise / Gözlem odasına gir",
                ru: "Попасть в запертый офис / Наблюдательную комнату"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "The Labyrinth", tr: "The Labyrinth", ru: "Лабиринт" },
                objective: {
                    en: "Use the Observation room key to enter the locked office.",
                    tr: "Kilitli ofise girmek için Gözlem odası anahtarını kullan.",
                    ru: "Используйте ключ от наблюдательной комнаты, чтобы войти в запертый офис."
                },
                requiredItems: [
                    { en: "Observation room key", tr: "Gözlem odası anahtarı", ru: "Ключ от наблюдательной комнаты" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Find the Observation room door within The Labyrinth.",
                            tr: "Labirent'teki Gözlem odası kapısını bul.",
                            ru: "Найдите дверь наблюдательной комнаты в Лабиринте."
                        },
                        images: ['/Story/Labyrinth/ObservationRoom-Map.webp']
                    },
                    {
                        text: {
                            en: "Use the Observation room key to unlock the door and enter.",
                            tr: "Kilidi açıp içeri girmek için Gözlem odası anahtarını kullan.",
                            ru: "Используйте ключ от наблюдательной комнаты, чтобы открыть дверь и войти."
                        },
                        images: ['/Story/Labyrinth/ObservationRoom-Door.webp']
                    }
                ]
            }
        },
        {
            id: 'step_listen_audio_tape',
            label: {
                en: "Listen to the audio tape from the office",
                tr: "Ofisteki ses kasetini dinle",
                ru: "Прослушать аудиокассету из офиса"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "The Labyrinth", tr: "The Labyrinth", ru: "Лабиринт" },
                objective: {
                    en: "Pick up and listen to the deceased scientist's audio tape in the observation room.",
                    tr: "Gözlem odasındaki ölü bilim adamının ses kasetini al ve dinle.",
                    ru: "Заберите и прослушайте аудиокассету мертвого ученого в наблюдательной комнате."
                },
                requiredItems: [
                    { en: "Deceased scientist's audio tape", tr: "Ölü bilim adamının ses kaseti", ru: "Аудиокассета мертвого ученого" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Inside the observation room, locate the scientist's body. The audio tape is under his right hand.",
                            tr: "Gözlem odasında bilim adamının cesedini bul. Ses kaseti sağ elinin altındadır.",
                            ru: "В наблюдательной комнате найдите тело ученого. Аудиокассета находится под его правой рукой."
                        },
                        images: ['/Story/Labyrinth/AudioTape-Location.webp', '/Story/Labyrinth/AudioTape-Item.webp']
                    }
                ]
            }
        },
        {
            id: 'step_handover_tape_jaeger',
            label: {
                en: "Hand over the audio tape to Jaeger",
                tr: "Ses kasetini Jaeger'e teslim et",
                ru: "Передать аудиокассету Егерю"
            },
            type: 'talk',
            isSubTask: false,
            details: {
                location: { en: "Menu / Traders", tr: "Menü / Satıcılar", ru: "Меню / Торговцы" },
                objective: {
                    en: "Give the deceased scientist's audio tape to Jaeger.",
                    tr: "Ölü bilim adamının ses kasetini Jaeger'e teslim et.",
                    ru: "Передайте аудиокассету мертвого ученого Егерю."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Open the Traders menu. Select Jaeger. Hand over the audio tape.",
                            tr: "Satıcılar menüsünü aç. Jaeger'i seç. Ses kasetini teslim et.",
                            ru: "Откройте меню торговцев. Выберите Егеря. Передайте аудиокассету."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_find_research_report',
            label: {
                en: "Read the Labyrinth facility research report",
                tr: "Labirent tesisi araştırma raporunu oku",
                ru: "Прочитать доклад об исследованиях объекта Лабиринт"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "The Labyrinth", tr: "The Labyrinth", ru: "Лабиринт" },
                objective: {
                    en: "Locate and obtain the Labyrinth facility research report.",
                    tr: "Labirent tesisi araştırma raporunu bul ve al.",
                    ru: "Найдите и заберите доклад об исследованиях объекта Лабиринт."
                },
                requiredItems: [
                    { en: "Labyrinth facility research report", tr: "Labirent tesisi araştırma raporu", ru: "Доклад об исследованиях объекта Лабиринт" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Return to The Labyrinth. Find the research report document.",
                            tr: "Labirent'e geri dön. Araştırma raporu belgesini bul.",
                            ru: "Вернитесь в Лабиринт. Найдите документ с исследовательским докладом."
                        },
                        images: ['/Story/Labyrinth/ResearchReport-Map.webp']
                    },
                    {
                        text: {
                            en: "Pick up and read the report to complete the objective.",
                            tr: "Görevi tamamlamak için raporu al ve oku.",
                            ru: "Заберите и прочитайте доклад, чтобы завершить задачу."
                        },
                        images: ['/Story/Labyrinth/ResearchReport-Item.webp']
                    }
                ]
            }
        },
        {
            id: 'step_complete_chain',
            label: {
                en: "Completing the chain",
                tr: "Görev zincirini tamamla",
                ru: "Завершение цепочки"
            },
            type: 'talk',
            isSubTask: false,
            details: {
                location: { en: "Menu / Traders", tr: "Menü / Satıcılar", ru: "Меню / Торговцы" },
                objective: {
                    en: "Complete the final dialogue to finish The Labyrinth chapter.",
                    tr: "Labirent bölümünü bitirmek için son diyalogu tamamla.",
                    ru: "Завершите финальный диалог, чтобы закончить главу «Лабиринт»."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Talk to the relevant trader to complete the chapter.",
                            tr: "Bölümü tamamlamak için ilgili satıcıyla konuş.",
                            ru: "Поговорите с соответствующим торговцем, чтобы завершить главу."
                        }
                    }
                ]
            }
        }
    ]
};